export const featuresEnGb = {
  annotations: {
    aiFeedbackAlert: {
      desktopPrompt: 'Right-click photo to give AI feedback!',
      improveAccuracy: 'Improve accuracy.',
      improveAccuracyFor: 'Improve accuracy for {{tradeCompanyName}}.',
      mobilePrompt: 'Tap & hold photo to give AI feedback!',
    },
    aiFeedbackSwitch: {
      label: 'Show AI feedback',
    },
    aiFilters: {
      analysisFailedDescription:
        'Our team will look into it. Meanwhile, please proceed to the remaining photos in the report.',
      analysisFailedTitle: 'AI was unable to analyze this photo',
      description: 'Show or hide the material outlines and compare them to the original photo.',
      noFiltersDescription:
        "Safi's AI only outlines non-target material (like impurities or attachments). This photo contains only target material (e.g. UBC or PET), so there are no outlines or filters to display.",
      noFiltersTitle: 'No filters to show as 100% target material detected',
      showOutlines: 'Show AI Outlines',
      title: 'Adjust AI Filters',
    },
    commentBubble: {
      actions: {
        deleteFeedback: 'Delete feedback',
        edit: 'Edit',
      },
      adminMeta: 'ID:{{commentId}} AI:{{aiVersion}}',
      deleteDialog: {
        confirm: 'Delete',
        message: 'Are you sure you want to delete this feedback? This action cannot be undone.',
        title: 'Delete feedback',
      },
    },
    commentFormDrawer: {
      actions: {
        cancel: 'Cancel',
        save: 'Save',
      },
      feedbackType: {
        incorrectDetection: 'Incorrect object detected',
        missingDetection: 'Object not detected',
      },
      labels: {
        note: 'Note',
      },
      titleCreate: 'Give AI feedback',
      titleEdit: 'Edit AI feedback',
    },
    helpAndFeedbackBar: {
      downloadFullImageAriaLabel: 'Download full evidence image',
    },
    segmentationOverlay: {
      ariaLabel: 'Image with segmentation overlay',
      helpText: {
        desktop: 'Hover over photo to zoom',
        mobile: 'Zoom in with fingers',
      },
    },
    speechBubbleAvatar: {
      viewCommentAriaLabel: 'View comment by {{fullName}}',
    },
  },
  auth: {
    companySignUpForm: {
      actions: {
        next: 'Next',
      },
      labels: {
        companyType: 'Company type',
        country: 'Country',
        name: 'Name',
      },
      notifications: {
        errorSigningUp: 'Error signing up',
      },
      validation: {
        companyTypeRequired: 'Company type is required',
        countryRequired: 'Country is required',
        nameRequired: 'Name is required',
      },
    },
    otpForm: {
      actions: {
        signIn: 'Sign in',
      },
      labels: {
        passcode: 'Passcode',
      },
      validation: {
        digitsOnly: 'Must be only digits',
        passcodeLength: 'One-time passcode must be 4 digits',
        passcodeRequired: 'One-time passcode is required',
      },
    },
    signInEmailForm: {
      actions: {
        next: 'Next',
      },
      labels: {
        email: 'Email',
      },
      links: {
        signInWithPhone: 'Sign in with phone number',
      },
      validation: {
        emailRequired: 'Email is required',
        invalidEmail: 'Invalid email',
        termsRequired: 'You must accept the terms and conditions',
      },
    },
    signInPage: {
      subtitle:
        "Sign into {{brandName}} with your work email or phone number. We'll send you a one-time passcode for faster access.",
      title: 'Quality control with confidence',
    },
    signInPhoneForm: {
      actions: {
        next: 'Next',
        signInWithEmail: 'Sign in with email',
      },
      labels: {
        phoneNumber: 'Phone number',
      },
      validation: {
        phoneNumberRequired: 'Phone number is required',
      },
    },
    termsAndPolicyAgreement: {
      fullSentence:
        'I accept the <termsLink>Terms & Conditions</termsLink> and the <privacyLink>Privacy Policy</privacyLink> by joining {{brandName}}.',
    },
    userSignUpForm: {
      actions: {
        next: 'Next',
      },
      labels: {
        email: 'Email',
        fullName: 'Full name',
        phoneNumber: 'Phone number',
      },
      notifications: {
        errorSigningUp: 'Error signing up',
      },
      validation: {
        emailRequired: 'Email is required',
        fullNameRequired: 'Full name is required',
        invalidEmail: 'Invalid email',
        phoneNumberRequired: 'Phone number is required',
        termsRequired: 'You must accept the terms and conditions',
      },
    },
  },
  backlog: {
    breakdowns: {
      evaluatedSpecsItems: {
        ungroupedMaterials: 'Ungrouped materials',
      },
      formatDirtScore: {
        average: 'Average',
        clean: 'Clean',
        dirty: 'Dirty',
        notAvailable: 'N/A',
        veryClean: 'Very Clean',
      },
      materialAiBreakdown: {
        aiModelNotSupported: 'AI model not supported',
      },
      materialLabels: {
        aluminium: 'Aluminium',
        aluminiumAerosol: 'Aluminium Aerosol',
        aluminiumFoodCan: 'Aluminium Food Can',
        brown: 'Brown',
        clear: 'Clear',
        clearNonFoodGrade: 'Clear, non-food-grade',
        clearPetTray: 'Clear PET Tray',
        petTrayContaminatedClear: 'Clear Contaminated PET Tray',
        darkBlue: 'Dark Blue',
        dirtyBottles: 'Dirty Bottles',
        expandedPolystyrene: 'Expanded Polystyrene',
        film: 'Film',
        foilAndTray: 'Foil and Tray',
        fullSleeve: 'Full Sleeve',
        green: 'Green',
        hdpe: 'HDPE',
        hdpeJazz: 'Jazz',
        hdpeNaturalFoodGrade: 'Natural Food Grade',
        hdpeNaturalNonFoodGrade: 'Natural Non-Food Grade',
        hdpeSiliconTubes: 'Silicon Tubes',
        hdpeWhiteFoodGrade: 'White Food Grade',
        hdpeWhiteNonFoodGrade: 'White Non-Food Grade',
        lightBlue: 'Light Blue',
        metal: 'Metal',
        nonAluminium: 'Non-Aluminium',
        nonHdpe: 'Non-HDPE',
        nonMetal: 'Non-Metal',
        nonPet: 'Non-PET',
        nonPlastic: 'Non-Plastic',
        oilBottle: 'Oil Bottle',
        other: 'Other',
        otherAluminium: 'Other Aluminium',
        otherColour: 'Other Colour',
        otherMetal: 'Other Metal',
        otherPlastic: 'Other Plastic',
        pet: 'PET',
        polypropylene: 'PP',
        prohibitive: 'Prohibitive',
        total: 'Total',
        ubc: 'UBC',
        waste: 'Waste',
        white: 'White',
      },
      representativeEvidenceFilter: {
        label: 'View images of:',
        options: {
          bestBales: 'Best Bales',
          typicalBales: 'Typical Bales',
          worstBales: 'Worst Bales',
        },
      },
      representativeEvidenceSection: {
        distributionTitle: '{{targetName}} distribution',
      },
      specificationAlerts: {
        groupDescription:
          '<boldAction>{{actionText}}</boldAction> - The <boldName>{{name}}</boldName> group is <boldComparison>{{comparison}}</boldComparison>',
        groupDescriptionWithoutComparison:
          '<boldAction>{{actionText}}</boldAction> - The <boldName>{{name}}</boldName> group is',
        groupIs: 'group is',
        the: '- The',
        title: 'Alerts',
      },
      totalWeightWarning: {
        message:
          'Warning! The total weight ({{formattedTotalWeight}}kg) is not the sum of the breakdown weights ({{formattedSum}}kg).',
      },
    },
    cameraGuidance: {
      useCameraStream: {
        notifications: {
          cannotUseCamera: 'Cannot use camera',
          refreshAndAllowCamera: 'Refresh this page and try again. Allow camera access when asked.',
        },
      },
    },
    common: {
      noData: 'No data',
    },
    dealDetails: {
      fields: {
        destination: 'Destination',
        endProcessor: 'End Processor',
        inspections: 'Inspections',
        loadingSite: 'Loading Site',
        loads: 'Loads',
        material: 'Material',
        producer: 'Producer',
        risk: 'Risk',
      },
      header: {
        deal: 'Deal {{dealId}}',
      },
    },
    dealRevenueDetails: {
      columns: {
        description: 'Description',
        id: 'ID',
        invoiceStatus: 'Invoice Status',
        invoiceXeroAmountPaid: 'Invoice Xero Amount Paid',
        invoiceXeroFullyPaidOn: 'Invoice Xero Fully Paid On',
        invoiceXeroId: 'Invoice Xero ID',
        lineTotal: 'Line Total',
        quantity: 'Quantity',
        unitAmount: 'Unit Amount',
      },
    },
    documentGeneration: {
      notifications: {
        failedToSaveFile: 'Failed to save file',
        failedToUploadFile: 'Failed to upload file',
      },
    },
    evidence: {
      baleEvidenceGallery: {
        analysingMultiplePhotos: 'Analysing {{count}} photos...',
        analysingSinglePhoto: 'Analysing {{count}} photo...',
        noEvidenceFound: 'No photos found',
      },
      bulkDownload: {
        empty: 'No evidence to download',
        error: 'Failed to download evidence',
        inProgress: 'Preparing evidence download…',
        partialSuccess: 'Downloaded {{downloaded}} of {{total}} photos',
        success: 'Downloaded {{count}} photos',
      },
      common: {
        editSample: 'Edit Sample',
        manageInspection: 'Manage inspection',
      },
      evidenceAiDetails: {
        aiAnalysisTitle: 'AI analysis',
        aiImagesTitle: 'AI images',
      },
      evidenceAiLooseSessionDetails: {
        aiLooseAnalysisTitle: 'AI Loose Analysis',
        sampleImagesTitle: 'Sample images',
      },
      evidencePhotosViewer: {
        bulkDeleteError: 'Failed to delete photos',
        bulkDeleteSuccess: 'Successfully deleted {{count}} photos',
      },
      loadingPhotoEvidenceGallery: {
        noOtherImagesAvailable: 'No other images available.',
      },
      manualBreakdownFormFields: {
        kilogramUnit: 'Kg',
      },
      sessionEditDialog: {
        actions: {
          editDeleteEvidence: 'Edit / Delete Evidence',
        },
      },
      sessionEvidenceEditDialog: {
        step1Title: 'Step 1. Select the evidence you want to modify',
        step2Title: 'Step 2. Specify how to modify the selected evidence',
      },
      sessionSummary: {
        anonymous: 'Anonymous',
        withOrigin: '{{origin}} - Uploaded by {{uploadedBy}}',
        withoutOrigin: 'Uploaded by {{uploadedBy}}',
      },
      uploadMenu: {
        downloadAllEvidence: 'Download all evidence',
        downloadingAllEvidence: 'Downloading…',
        editEvidence: 'Edit evidence',
        menuAriaLabel: 'More actions',
        offlineModeComingSoon: 'Offline mode coming soon',
        openCamera: 'Open camera',
        uploadEvidence: 'Upload evidence',
      },
      uploadOptionsButton: {
        actions: {
          upload: 'Upload',
        },
        options: {
          openCamera: 'Open Camera',
          uploadPhoto: 'Upload Photo',
        },
      },
    },
    evidenceGrid: {
      columns: {
        evidence: 'Evidence',
      },
    },
    evidenceUploadButton: {
      label: 'Upload',
      notifications: {
        failedToUploadEvidence: 'Failed to upload evidence',
        failedToUploadPhoto: 'Failed to upload {{photoName}}: {{error}}',
        successfullyUploadedEvidence: 'Successfully uploaded evidence',
      },
    },
    externalLoad: {
      common: {
        supplier: 'Supplier',
      },
    },
    findTicketsTable: {
      columns: {
        category: 'Category',
        status: 'Status',
        summary: 'Summary',
        team: 'Team',
      },
    },
    firmQuoteBulkForm: {
      columns: {
        bunkerAdjustmentFactorCost: 'Bunker Adjustment Factor Cost',
        bunkerAdjustmentFactorCurrency: 'Bunker Adjustment Factor Currency',
        carrier: 'Carrier',
        containerType: 'Container Type',
        demandIncoterm: 'Demand Incoterm',
        destinationCountry: 'Destination Country',
        destinationLat: 'Destination Lat',
        destinationLon: 'Destination Lon',
        destinationName: 'Destination Name',
        directLandCost: 'Direct Land Cost',
        directLandCurrency: 'Direct Land Currency',
        e2eCost: 'E2E Cost',
        e2eCurrency: 'E2E Currency',
        estimatedDeparture: 'Est. Departure',
        expiresOn: 'Expires On',
        forwarder: 'Forwarder',
        notes: 'Notes',
        oceanFreightCost: 'Ocean Freight Cost',
        oceanFreightCurrency: 'Ocean Freight Currency',
        onCarriageCost: 'On-carriage Cost',
        onCarriageCurrency: 'On-carriage Currency',
        originCountry: 'Origin Country',
        originLat: 'Origin Lat',
        originLon: 'Origin Lon',
        originName: 'Origin Name',
        peakSeasonSurchargeCost: 'Peak Season Surcharge Cost',
        peakSeasonSurchargeCurrency: 'Peak Season Surcharge Currency',
        portOfDischarge: 'POD',
        portOfLoading: 'POL',
        preCarriageCost: 'Pre-carriage Cost',
        preCarriageCurrency: 'Pre-carriage Currency',
        quotedOn: 'Quoted On',
        supplyIncoterm: 'Supply Incoterm',
        typeOfGoods: 'Type of Goods',
      },
    },
    grade: {
      compositionReport: {
        annotatedBaleAlt: 'Annotated Bale',
      },
      imageQualityPrompt: {
        label: 'Retake',
      },
    },
    groundControl: {
      common: {
        descriptions: {
          calculateDealProfitability: 'Calculate deal profitability',
          createPurchaseOrderAndSendToSeller: 'Create a Purchase Order and send it to the seller for signing',
          createSalesOrderAndSendToBuyer: 'Create a Sales Order and send it to the buyer for signing',
          viewEditAndMatch: 'View, edit and match',
        },
        labels: {
          createPurchaseOrder: 'Create Purchase Order',
          createSalesOrder: 'Create Sales Order',
          dealProfitabilityCalculator: 'Deal Profitability Calculator',
          viewPurchaseOrders: 'View Purchase Orders',
          viewSalesOrders: 'View Sales Orders',
        },
      },
      tabs: {
        advanced: {
          label: 'Advanced',
          links: {
            manageMaterialProducts: {
              description: 'View and edit Material Products',
              label: 'Manage Material Products',
            },
            pernType: {
              description: 'Update PERN types',
              label: 'Pern Type',
            },
          },
        },
        contracts: {
          label: 'Contracts',
        },
        deals: {
          label: 'Deals',
          links: {
            goToDealHub: {
              description: 'View and action deal tasks',
              label: 'Go To DealHub',
            },
            viewAllDeals: {
              description: 'View and edit all deals and loads',
              label: 'View All Deals',
            },
          },
        },
        finance: {
          label: 'Finance',
          links: {
            createShippingRate: {
              description: 'Create Shipping Rate and all associated details',
              label: 'Create Shipping Rate',
            },
            manageBanks: {
              description: 'View and edit Bank Details',
              label: 'Manage Banks',
            },
            manageCosts: {
              description: 'Create, edit and view costs',
              label: 'Manage Costs',
            },
            manageExternalCompanies: {
              description: 'Create, edit and view External Company Details',
              label: 'Manage External Companies',
            },
            manageFinancing: {
              description: 'Submit Payment Requests to Finmid',
              label: 'Manage Financing',
            },
            manageRevenue: {
              description: 'Create, edit and view Revenue',
              label: 'Manage Revenue',
            },
            marketPernPrices: {
              description: 'View historical PERN prices from T2E',
              label: 'Market PERN Prices',
            },
          },
        },
        inspections: {
          label: 'Inspections',
          links: {
            addExternalEvidence: {
              description: 'Add evidence from external sources',
              label: 'Add External Evidence',
            },
            addSiteEvidence: {
              description: 'Add new site evidence',
              label: 'Add Site Evidence',
            },
            createInspection: {
              description: 'Create a new inspection',
              label: 'Create Inspection',
            },
            inspectionCompanies: {
              description: 'View and edit inspection companies',
              label: 'Inspection companies',
            },
            inspections: {
              description: 'View and edit inspections',
              label: 'Inspections',
            },
            inspectors: {
              description: 'View and edit inspectors',
              label: 'Inspectors',
            },
            viewUpcomingLoads: {
              description: 'View and edit upcoming loads',
              label: 'View Upcoming Loads',
            },
          },
        },
        support: {
          label: 'Support',
          links: {
            getSupport: {
              description: 'Create a Jira support issue',
              label: 'Get Support',
            },
            helpAndLearn: {
              description: 'Help guides',
              label: 'Help & learn',
            },
          },
        },
        trade: {
          label: 'Trade',
          links: {
            createDemandSignal: {
              description: 'Create a demand signals. It will be synced with Hubspot',
              label: 'Create Demand Signal',
            },
            createSupplySignal: {
              description: 'Create a supply signal. It will be synced with Hubspot',
              label: 'Create Supply Signal',
            },
            generateDocuments: {
              description: 'Generate documents for Purchase Orders, Sales Orders, Shipments, etc.',
              label: 'Generate Documents',
            },
            qualityReport: {
              description: 'Add quality Report Data and Images',
              label: 'Quality Report',
            },
            transportMetabase: {
              description: 'Link to Transport Metabase',
              label: 'Transport Metabase',
            },
          },
        },
        transport: {
          label: 'Transport',
          links: {
            manageCarriers: {
              description: 'Create, edit and view Carriers',
              label: 'Manage Carriers',
            },
            syncTransportCosts: {
              description: 'Sync transport costs from spreadsheet',
              label: 'Sync Transport Costs',
            },
            viewPorts: {
              description: 'View all Ports',
              label: 'View Ports',
            },
          },
        },
        usersAndCompanies: {
          label: 'Users & companies',
          links: {
            copySessions: {
              description: 'Copy sessions into ML Accuracy Testing from a CSV upload',
              label: 'Copy Sessions',
            },
            createUserAndCompany: {
              description: 'Create a user and new company, or invite to an existing company',
              label: 'Create user and company',
            },
            hijackUser: {
              description: 'Quickly hijack a user account',
              label: 'Hijack a user',
            },
            staffOnboarding: {
              description: 'Create a new admin user and make them a member of Safi',
              label: 'Staff Onboarding',
            },
            viewAllUsers: {
              description: 'View all users in HubSpot',
              label: 'View all users',
            },
            viewTradeCompanies: {
              description: 'View and edit supply & demand trading companies',
              label: 'View all trade companies',
            },
          },
        },
      },
    },
    guidePriceChip: {
      label: 'Guide price',
      unavailable: 'Guide price unavailable',
    },
    helpGuides: {
      aiBale: {
        partOne: {
          boldText: 'Stand 1 metre max',
          imageAlt: 'Stand 1 metre away max',
          trailingText: 'in front of the pile.',
        },
      },
      aiLoose: {
        partFour: {
          and: 'and',
          clearPile: 'Clear away the pile',
          imageAlt: 'Clear pile',
          repeatSteps: 'repeat steps 1-3',
          untilText: 'until you have taken one photo per pile for the whole sample.',
        },
        partOne: {
          imageAlt: 'Make a pile',
          makePile: 'Make a pile',
          middleText: 'from your sample and spread it evenly on the floor.',
          takePhoto: 'Take 1 photo per pile.',
        },
        partThree: {
          boldIntro: 'Check the photo before clearing away your pile.',
          imageAlt: 'Review delete',
          trailingText: "If it's not correct, you can delete it and take a new one.",
          warningBold: '1 photo per pile only',
          warningPrefix: 'Upload',
          warningSuffix: 'to avoid skewing the AI results.',
        },
      },
      common: {
        completeAlt: 'Complete',
      },
      data: {
        guides: {
          aiBale: 'AI Bale',
          aiBriquette: 'AI Briquette',
          aiLoose: 'AI Loose',
        },
        sections: {
          qualityControlGuides: 'Quality control guides',
        },
        subcategories: {
          howToTakeGreatAiPhotos: 'How to take great AI photos',
        },
      },
    },
    inspectionMutate: {
      cancellationReasons: {
        dealCancelled: 'Deal Cancelled',
        missedLoading: 'Missed Loading',
        noCoverage: 'No Coverage',
        noInspector: 'No Inspector',
        notNeeded: 'Not Needed',
        other: 'Other',
        siteRefused: 'Site Refused',
      },
      inspectionResults: {
        failed: 'Failed',
        passed: 'Passed',
        pending: 'Pending',
      },
      inspectionStatuses: {
        backlog: 'Backlog',
        booked: 'Booked',
        cancelled: 'Cancelled',
        complete: 'Complete',
        planning: 'Planning',
        scheduled: 'Scheduled',
      },
      inspectionTypes: {
        pern: 'Pern',
        sirim: 'Sirim',
        standard: 'Standard',
        supplier: 'Supplier',
      },
    },
    inspectionsList: {
      columns: {
        company: 'Company',
        deal: 'Deal',
        endProcessor: 'End Processor',
        inspector: 'Inspector',
        loads: 'Loads',
        material: 'Material',
        producer: 'Producer',
        risk: 'Risk',
        slug: 'Slug',
        status: 'Status',
        time: 'Time',
      },
      values: {
        notAvailable: 'N/A',
      },
    },
    loadDetails: {
      actions: {
        notNeeded: 'Not Needed',
      },
      fields: {
        collectionTime: 'Collection Time',
        inspection: 'Inspection',
        status: 'Status',
      },
      values: {
        hasInspection: 'Has Inspection',
        noInspection: 'No Inspection',
      },
    },
    loadsList: {
      columns: {
        collectionTime: 'Collection time',
        deal: 'Deal',
        destination: 'Destination',
        endProcessor: 'End Processor',
        hasInspection: 'Has inspection',
        load: 'Load',
        loadingSite: 'Loading site',
        material: 'Material',
        producer: 'Producer',
        risk: 'Risk',
        status: 'Status',
      },
      values: {
        no: 'No',
        notAvailable: 'N/A',
        yes: 'Yes',
      },
    },
    manageDataButton: {
      buttonLabel: 'Manage Data',
      options: {
        aiBalePhotos: 'AI Bale Photos',
        loadingEvidence: 'Loading Evidence',
        marketingMedia: 'Marketing Media',
        samples: 'Samples',
        siteEvidence: 'Site Evidence',
        specifications: 'Specifications',
      },
    },
    materialCategoryActions: {
      notifications: {
        cannotSaveMaterial: 'Cannot save material',
        errorCreatingMaterial: 'Error creating material',
        errorDeletingMaterial: 'Error deleting material',
        errorSavingMaterial: 'Error saving material',
        savedSuccessfully: 'Saved successfully',
        selectedTargetGroupHasNoOperands: 'Selected target group has no operands. Please choose another target group.',
        skippedSpecifications: "{{count}} specification(s) were not saved because they don't have operands assigned.",
      },
    },
    materialComponents: {
      supportedComponentList: {
        buttonText: 'Add material component',
        title: 'Material components',
      },
    },
    materialDirtLevel: {
      options: {
        clean: 'Clean',
        dirty: 'Dirty',
        notAvailable: 'N/A',
        veryClean: 'Very Clean',
      },
    },
    materialProducts: {
      validation: {
        atLeastOneBuyerMaterialComponentIsRequired: 'At least one buyer material component is required.',
        atLeastOneSellerMaterialComponentIsRequired: 'At least one seller material component is required.',
        buyerAndSellerMaterialComponentCountsMustMatch:
          'The number of buyer and seller material component values must be the same.',
      },
    },
    materialProductsList: {
      columns: {
        buyerMaterialComponents: 'Buyer Material Components',
        capsAndLabels: 'Caps and labels',
        country: 'Country',
        foodGrade: 'Food grade',
        id: 'ID',
        materialGrade: 'Material grade',
        materialOrigin: 'Material origin',
        materialSpec: 'Material spec',
        process: 'Process',
        sellerMaterialComponents: 'Seller Material Components',
      },
      values: {
        no: 'No',
        notSpecified: 'N/A',
        yes: 'Yes',
      },
    },
    notificationParty: {
      label: 'Notification party',
      options: {
        allViaAgent: 'All communications via agent',
        directWithBuyer: 'Communicate directly with the buyer',
      },
    },
    orders: {
      validation: {
        fixedPriceAndDateMustBeProvidedTogether: 'Fixed price and fixed date must be provided together',
      },
    },
    paymentMethod: {
      label: 'Payment method',
      options: {
        documentAgainstPayment: 'Document against payment',
        telegraphicTransfer: 'Telegraphic transfer',
      },
    },
    percentageLightBlue: {
      label: 'Percentage light blue',
      options: {
        notAvailable: 'N/A',
      },
    },
    qualityReport: {
      evidenceTabs: {
        aiBaleAnalysis: 'AI Bale Analysis',
        aiLooseAnalysis: 'AI Loose Analysis',
        loading: 'Loading',
        manualWeightSample: 'Manual Weight Sample',
        marketing: 'Marketing',
        materialSpecification: 'Material Specification',
        site: 'Site',
      },
      siteMaterialQualityReportHeader: {
        evidencePhotoAlt: 'Evidence photo',
      },
    },
    qualityReportSummary: {
      titles: {
        availableMaterial: 'Available Material',
        deliveryLocation: 'Delivery Location',
        estimatedDelivery: 'Estimated Delivery',
        location: 'Location',
        material: 'Material',
        materialGrade: 'Material Grade',
        tonnesPerLoad: 'Tonnes per load',
      },
    },
    siteMaterials: {
      notifications: {
        errorCreatingMaterial: 'Error creating material',
        materialCreated: 'Material created',
        productLinkedSuccessfully: 'Product linked successfully',
      },
    },
    timeFilter: {
      options: {
        last30Days: 'Last 30 days',
        last7Days: 'Last 7 days',
        last90Days: 'Last 90 days',
        next14Days: 'Next 14 days',
        next2Days: 'Next 2 days',
        next7Days: 'Next 7 days',
      },
    },
    variablePricingFields: {
      indexOptions: {
        lmeAluminium: 'LME Aluminium',
        lmeAluminiumMidwestPremium: 'LME Aluminium + Midwest Premium',
      },
    },
  },
  breakdowns: {
    adminAiVersionTitle: {
      value: 'AI:{{version}}',
    },
    aiSampleBreakdown: {
      analysisNotAvailable: 'Analysis not available',
    },
    aluMaterialSampleBreakdown: {
      labels: {
        aluminium: 'Aluminium',
        foilAndTray: 'Foil and Tray',
        foodCan: 'Food Can',
        nonAluminium: 'Non-Aluminium',
        nonMetal: 'Non-Metal',
        otherAluminium: 'Other Aluminium',
        otherMetal: 'Other Metal',
        total: 'Total',
        ubc: 'UBC',
      },
    },
    cleanliness: {
      label: 'Cleanliness',
      tooltip:
        'Cleanliness is a measure of how clean the material is. This ranges from very clean, clean, average and dirty. Dirt includes grease, spots and dust present on the surface of the material.',
    },
    evaluatedSpecsBreakdown: {
      customizeTableFor: 'Customise the table for',
      targetChip: 'Target',
      thisMaterial: 'this material',
      title: 'AI Analysis',
    },
    noAnalysisAlert: {
      description:
        "The AI couldn't analyse the photos. You can check the reason on each photo, delete the rejected ones, and try again.",
      guidance: 'See the <guideLink>{{guideLabel}} guide</guideLink> for tips on taking better photos.',
      noSubmittedPhotosDescription: 'No photos have been submitted for analysis yet. Add photos to start the analysis.',
      title: 'No results available',
    },
    analysisInProgressAlert: {
      pendingTitle: 'Analysis in progress',
      pendingDescription:
        '{{pendingCount}} of {{submittedCount}} photos are still being analysed. Results should appear within a few minutes.',
      partialTitle: 'More photos are being analysed',
      partialDescription:
        'Results below are based on {{acceptedCount}} of {{submittedCount}} photos. {{pendingCount}} more are still being analysed.',
      rejectedDescription: '{{rejectedCount}} photos were rejected. Check the reason on each photo.',
    },
    petFlake: {
      fields: {
        bulkDensity: 'Bulk density',
        clearFlakes: 'Clear flakes',
        colouredFlakes: 'Coloured flakes',
        darkBlueFlakes: 'Dark blue flakes',
        ferrousMetal: 'Ferrous metal',
        glue: 'Glue',
        greenFlakes: 'Green flakes',
        intrinsicViscosity: 'Intrinsic viscosity',
        isophthalicAcid: 'Isophthalic acid',
        lightBlueFlakes: 'Light blue flakes',
        meltFlowRate: 'Melt flow rate (MF) index (260°C/2,16Kg)',
        meltingPoint: 'Melting point',
        nonFerrousMetal: 'Non-ferrous metal',
        otherImpurities: 'Other impurities',
        paper: 'Paper',
        particlesSizeBetween10And12mm: 'Particles with size between 10 and 12 mm',
        particlesSizeBetween5And10mm: 'Particles with size between 5 and 10 mm',
        particlesSizeLt5mm: 'Particles with size < 5 mm',
        petContent: 'Polyethylene terephthalate (PET) content',
        ph: 'pH',
        polyolefinContamination: 'Polyolefin contamination',
        pvcContamination: 'PVC contamination',
        residualContamination: 'Residual contamination',
        residualMoisture: 'Residual moisture',
        sampledBy: 'Sampled by',
        woodenMaterials: 'Wooden materials',
        yellowFlakes: 'Yellow flakes',
      },
    },
    petMaterialSampleBreakdown: {
      labels: {
        clear: 'Clear',
        clearNonFoodGrade: 'Clear, non-food-grade',
        clearPetTray: 'Clear PET Tray',
        darkBlue: 'Dark Blue',
        film: 'Film',
        green: 'Green',
        largeClear5L: 'Large Clear (≥5L)',
        lightBlue: 'Light Blue',
        liquid: 'Liquid',
        nonPetBottle: 'Non-PET Bottle',
        nonPlastic: 'Non Plastic',
        other: 'Other',
        otherPlastic: 'Other Plastic',
        petBottle: 'PET Bottle',
        prohibitive: 'Prohibitive',
        total: 'Total',
      },
    },
    taintTaborMaterialSampleBreakdown: {
      labels: {
        aluIron: 'Alu./iron',
        aluNonMetal: 'Alu./non-metal',
        aluWithAttachments: 'Alu. w/ attachments',
        aluminium: 'Aluminium',
        cast: 'Cast',
        castIron: 'Cast/iron',
        ferrousMetal: 'Ferrous Metal',
        finesLt20mm: 'Fines <20mm',
        nonAluminium: 'non-Aluminium',
        nonMetal: 'Non-Metal',
        otherMetal: 'Other Metal',
        prohibitive: 'Prohibitive',
        radiatorCondenser: 'Radiator/Condenser',
        stainlessSteel: 'Stainless Steel',
        taintTabor: 'Taint Tabor',
        total: 'Total',
        ubcFoil: 'UBC/Foil',
      },
    },
    zorbaMaterialSampleBreakdown: {
      labels: {
        aluminiumUbc: 'Aluminium - UBC',
        compositeMaterials: 'Composite Materials',
        copperBrassRedsYellows: "Copper & Brass - 'reds & yellows'",
        finesLt20mm: 'Fines <20mm',
        nonFerrousMetalWhites: "Non-ferrous metal - 'whites'",
        nonTarget: 'Non-target',
        otherMetalFerrous: 'Other Metal (ferrous)',
        otherNonMetal: 'Other Non-Metal',
        postConsumerAluminiumPackaging: 'Post-consumer Aluminium Packaging',
        prohibitive: 'Prohibitive',
        targetMaterial: 'Target Material',
        total: 'Total',
      },
    },
  },
  cameraGuidance: {
    camera: {
      notifications: {
        autoCaptureOff: 'Auto capture off',
        autoCaptureOn: 'Auto capture on',
      },
      rejectedPhotos: {
        message: 'Tap the photo below to see the error reason, then delete the photo and try again',
        photo: 'photo',
        photos: 'photos',
        title: '{{prefix}} to check {{count}} {{countLabel}}!',
        titlePrefixObfuscated: 'Failed',
        titlePrefixWithAi: 'The AI failed',
      },
    },
    cameraFooter: {
      actions: {
        capture: 'Capture',
        complete: 'Complete',
        guide: 'Guide',
      },
      tooltips: {
        takePhotoToComplete: 'Take a photo to complete',
      },
    },
    cameraHeader: {
      autoCapture: 'Auto Capture',
      flashAriaLabel: 'Toggle flash',
      confirmationDialog: {
        actions: {
          complete: 'Complete',
          exitAnyway: 'Exit anyway',
        },
        messageWithAiLabel:
          "Your photos will be saved but you won't see AI results right away. To view the AI report now, tap Complete.",
        messageWithoutAiLabel:
          "Your photos will be saved but you won't see results right away. To view the report now, tap Complete.",
        title: 'Exit camera?',
      },
      settings: {
        description: 'Use offline mode if your data connection is weak to avoid losing photos',
        title: 'Settings',
      },
    },
    countdownOverlay: {
      snap: 'Snap!',
    },
    previewImageReview: {
      actions: {
        deleteAndRetake: 'Delete & retake',
      },
      evidencePhotoAlt: 'Evidence photo',
    },
  },
  charts: {
    targetBaleWeightsHistogram: {
      axes: {
        x: 'Predicted target content %',
        y: 'Number of bales',
      },
      labels: {
        average: 'Average: {{targetGrade}}%',
        bales: 'Bales',
      },
      tooltip: {
        label: 'Detected %: {{label}}',
        value: '{{value}} bales',
      },
    },
  },
  dataCards: {
    aiLooseAnalysis: {
      description:
        'A streamlined sample process with weights estimated from Safi AI. Values are rounded to nearest 0.01 kg.',
      latestInspectionTitle: 'Latest Inspection',
      showMediaLabel: 'Show media',
      title: 'AI Loose Analysis',
    },
    aluminiumComposition: {
      reportTitle: 'Report',
      targetDistributionTitle: 'Target distribution',
    },
    common: {
      loads: 'Loads',
      metricTonnes: 'Metric tonnes',
    },
    hdpeComposition: {
      aiBaleAnalysisTitle: 'AI Bale Analysis',
      reportTitle: 'Report',
    },
    hdpeCompositionQualityReport: {
      actions: {
        showMedia: 'Show media',
      },
      description:
        '<bold>HDPE Weight Analysis</bold> showing the percentage of material detected in a range of bales inspected historically by Safi inspectors.',
      fields: {
        latestInspection: 'Latest Inspection',
        supplierBalesAnalysed: 'Supplier Bales Analysed',
      },
      title: 'AI Bale Analysis',
    },
    loadingDetails: {
      actions: {
        showMedia: 'Show media',
      },
      fields: {
        loadingNotes: 'Loading notes',
        loadingTechnique: 'Loading technique',
        packedOn: 'Packed On',
        targetPayload: 'Target payload',
      },
      title: 'Loading details',
      values: {
        targetPayloadMt: '{{targetPayload}} (MT)',
      },
    },
    materialNotAnalysed: {
      analysisTitle: 'Analysis',
      noResultsDescription:
        'We have not built a model for this specific material type yet. But with more data, we will be able to provide analysis in the future.',
      noResultsTitle: 'No results available',
      reportTitle: 'Report',
    },
    materialSpecifications: {
      actions: {
        showMedia: 'Show media',
      },
      analysis: {
        completed: 'Completed',
        notCompleted: 'Not Completed',
      },
      fields: {
        baleDimensions: 'Bale Dimensions',
        capsAndLabels: 'Caps and Labels',
        density: 'Density (kg/m³)',
        ferrousCheck: 'Ferrous Check',
        foodGrade: 'Food Grade',
        materialAnalysisNotes: 'Material Analysis Notes',
        materialForm: 'Material Form',
        materialProcess: 'Material Process',
        origin: 'Origin',
        radiationCheck: 'Radiation Check',
        strapping: 'Strapping',
        visualCheck: 'Visual Check',
      },
      title: 'Material Specifications',
      units: {
        meters: 'm',
      },
      values: {
        no: 'No',
        yes: 'Yes',
      },
    },
    petComposition: {
      aiBaleAnalysisTitle: 'AI Bale Analysis',
      reportTitle: 'Report',
    },
    petCompositionQualityReport: {
      actions: {
        showMedia: 'Show media',
      },
      description:
        '<bold>PET Weight Analysis</bold> showing the percentage of material detected in a range of bales inspected historically by Safi inspectors.',
      fields: {
        latestInspection: 'Latest Inspection',
        supplierBalesAnalysed: 'Supplier Bales Analysed',
      },
      title: 'AI Bale Analysis',
    },
    site: {
      actions: {
        showMedia: 'Show media',
      },
      fields: {
        machinesUsed: 'Machines Used',
        materialOrigin: 'Material Origin',
        monthlyVolume: 'Monthly Volume',
        siteGround: 'Site Ground',
        siteNotes: 'Site Notes',
        storageAndCover: 'Storage & Cover',
      },
      monthlyVolumeValue: '{{productionVolume}} (MT)',
      title: 'Site',
    },
    targetBaleWeights: {
      actions: {
        showMedia: 'Show media',
      },
      attachmentDetails: {
        foodCan: 'Food Can',
        nonMetal: 'Non-Metal',
        otherAluminium: 'Other Aluminium',
        otherMetal: 'Other Metal',
        title: 'Attachment details',
      },
      callouts: {
        attachmentWeightContent: 'Attachment Weight Content',
        averageUbcWeightContent: 'Average UBC Weight Content',
      },
      evidencePhotoAlt: 'evidence photo',
      inspectorsGatheredMessage:
        'Inspectors have gathered data from analysing <bold>{{count}}</bold> bales from <bold>{{from}}</bold> and <bold>{{to}}</bold>',
      inspectorsGatheredPrefix: 'Inspectors have gathered data from analysing',
      showBaleQualityData: 'Show bale quality data',
      tabs: {
        bestBales: 'Best bales',
        typicalBales: 'Typical bales',
        ubcSuffix: 'UBC',
      },
      title: 'AI Bale Analysis',
    },
    tradeCompanySessionLoose: {
      aiLooseAnalysisTitle: 'AI Loose Analysis',
      reportTitle: 'Report',
      sampleTotalWeightTitle: 'Sample total weight',
    },
    transactionHistory: {
      alerts: {
        newSupplier: "New supplier! You haven't purchased from them before.",
        purchasedBefore: "You've purchased from this supplier before!",
      },
      title: 'Transaction History',
      total: {
        description: 'Transactions between this supplier and other buyers in the past 6 months.',
      },
    },
    weightSampleAnalysis: {
      actions: {
        showMedia: 'Show media',
      },
      description: {
        withTotalWeight:
          'Data is based on the most recent manual sample of {{totalWeightInKg}} of supplier output material, completed by a Safi inspector. Values are rounded to nearest 0.01 kg.',
        withoutTotalWeight: 'Values are rounded to nearest 0.01 kg.',
      },
      labels: {
        latestInspection: 'Latest inspection',
      },
      title: 'Manual Sample Analysis',
    },
  },
  evidence: {
    actionBar: {
      deletePrompt: 'Are you sure you want to delete the selected evidence?',
      deleteTitle: 'Delete {{evidence}}',
      selectedCount: '{{selected}} selected',
    },
    chips: {
      ai: 'AI',
      selfServe: 'Self-Serve',
    },
    defaultBreakdownFormFields: {
      actions: {
        addBreakdownItem: 'Add Breakdown Item',
      },
      labels: {
        name: 'Name',
        unit: 'Unit',
        value: 'Value',
      },
      title: 'Breakdown',
    },
    editForm: {
      actions: {
        delete: 'Delete',
        edit: 'Edit',
      },
      labels: {
        newEvidenceType: 'New {{evidence}} Type',
        newLabel: 'New',
        typeLabel: 'Type',
      },
      notifications: {
        deleteError: 'Error deleting evidence',
        deleteSuccess: 'Evidence deleted',
        updateError: 'Error updating evidence',
        updateSuccess: 'Evidence updated',
      },
      validation: {
        typeOrSiteMaterialRequired: 'Either evidence type or site material must be provided',
      },
      warnings: {
        deleteMessage:
          'You are about to delete this evidence from this site material. This will remove it from the associated quality report. Please confirm to continue.',
        editMessage:
          'You are about to change this evidence. This will remove it from the associated quality report. Please confirm to continue.',
        title: 'Warning!',
      },
    },
    inspectionSessionDetails: {
      labels: {
        dealId: 'Deal ID:',
        inspectionSlug: 'Inspection slug:',
      },
      tooltips: {
        reportAvailableOnCompletion: 'Once the inspection is completed, you will find here a link to the report.',
        searchInDrive: 'Search for inspection in Google Drive',
        viewDealDetails: 'View deal details',
        viewExternalReport: 'View external report',
      },
    },
    offlineGallery: {
      notifications: {
        clearError: 'Failed to clear offline evidence',
        clearSuccess: 'Successfully cleared offline evidence',
      },
      title: 'Offline {{evidenceLower}}',
      tooltips: {
        cannotSyncWhileOffline: 'Cannot sync while offline',
        clear: 'Clear offline evidence',
        sync: 'Sync offline evidence',
        syncInProgress: 'Sync in progress...',
      },
    },
    sampleBreakdown: {
      labels: {
        aiBreakdown: 'AI Breakdown',
        manualBreakdown: 'Manual Breakdown',
        noNotes: 'No Notes',
        sample: 'Sample',
        sampleEvidence: 'Sample Evidence',
      },
      totalWeight: '{{totalWeight}}kg',
    },
    sampleFormFields: {
      breakdowns: {
        alu: {
          groups: {
            aluminium: 'Aluminium',
            nonAluminium: 'Non-Aluminium',
          },
          items: {
            foilAndTray: 'Foil and Tray',
            foodCan: 'Food Can',
            nonMetal: 'Non-Metal',
            otherAluminium: 'Other Aluminium',
            otherAluminiumAerosols: 'Other Aluminium (aerosols)',
            otherMetal: 'Other Metal',
            rigidPlastics: 'Rigid Plastics',
            ubc: 'UBC',
            vapes: 'Vapes',
          },
        },
        pet: {
          groups: {
            otherPetAndPlastics: 'Other PET & Plastics',
            petBottles: 'PET Bottles',
          },
          items: {
            clear: 'Clear',
            clearFullSleeve: 'Clear (Full Sleeve)',
            clearLarge: 'Clear (Large)',
            clearPetTray: 'Clear PET Tray',
            darkBlue: 'Dark Blue',
            film: 'Film',
            green: 'Green',
            lightBlue: 'Light Blue',
            liquid: 'Liquid',
            nonFoodGradeBottle: 'Non Food Grade PET Bottle',
            nonPlastic: 'Non Plastic',
            other: 'Other',
            otherPlastic: 'Other Plastic',
            prohibitive: 'Prohibitive',
          },
        },
        taintTabor: {
          groups: {
            aluWithAttachments: 'Alu. w/ attachments',
            aluminium: 'Aluminium',
            nonAluminium: 'non-Aluminium',
          },
          items: {
            aluIron: 'Alu./iron',
            aluNonMetal: 'Alu./non-metal',
            cast: 'Cast',
            castIron: 'Cast/iron',
            ferrousMetal: 'Ferrous Metal',
            finesLt20mm: 'Fines <20mm',
            nonMetal: 'Non-Metal',
            otherMetal: 'Other Metal',
            prohibitive: 'Prohibitive',
            radiatorCondenser: 'Radiator/Condenser',
            stainlessSteel: 'Stainless Steel',
            taintTabor: 'Taint Tabor',
            ubcFoil: 'UBC/Foil',
          },
        },
        zorba: {
          groups: {
            nonTarget: 'Non-target',
            targetMaterial: 'Target Material',
          },
          items: {
            aluminiumFoilUbc: 'Aluminium - foil / UBC',
            compositeMaterials: 'Composite Materials',
            copperAndBrass: "Copper & Brass 'reds & yellows'",
            finesLt20mm: 'Fines <20mm',
            nonFerrousMetal: "Non-ferrous Metal 'whites'",
            otherMetalFerrous: 'Other metal (ferrous)',
            otherNonMetal: 'Other Non-metal',
            postConsumerAluminiumPackaging: 'Post-consumer Aluminium Packaging',
            prohibitive: 'Prohibitive',
          },
        },
      },
      labels: {
        notes: 'Notes',
        totalWeight: 'Total Weight',
        weightUnit: 'Kg',
      },
    },
    sampleMaterialEditForm: {
      actions: {
        edit: 'Edit',
      },
      warning: {
        editMessage:
          'You are about to change this evidence. This will remove it from the associated quality report. Please confirm to continue.',
        title: 'Warning!',
      },
    },
    sampleSessionDetails: {
      manualSampleAnalysisTitle: 'Manual sample analysis',
      noData: 'No data',
      sampleImagesTitle: 'Sample images',
    },
    sessionStats: {
      excludedSubtitle: 'Images failed our requirement rules',
      excludedTitle: 'Excluded',
      includedSubtitle: 'Images passed our requirement rules',
      includedTitle: 'Included',
    },
    unloadingPhotoUploader: {
      label: 'Upload photos',
      notifications: {
        uploadFailed: 'Upload failed',
        uploadSuccess: 'Upload successful',
      },
    },
  },
  helpGuides: {
    aiBale: {
      partTwo: {
        captions: {
          clearWhichBaleToFocusOn: 'Clear which bale to focus on',
          goodQualityPhoto: 'Good quality photo',
          goodQualityPhotoAndDistanceFromBale: 'Good quality photo and distance from bale',
          greatDistanceFromBale: 'Great distance from bale',
          materialNotTooTightlyPacked: 'Material is not too tightly packed',
          materialTooFlatAndTightlyPacked: 'Material is too flat and tightly packed',
          nearlyAllBaleFaceShown: 'Nearly all of the bale face is shown',
          photoTooBlurry: 'Photo is too blurry',
          someBackgroundIsOk: 'Some background is ok',
          tooClose: 'Too close',
          tooManyBalesAngleNotStraightPoorQuality: 'Too many bales, angle is not straight on, poor quality',
          tooManyBalesManySidesVisible: 'Too many bales, many sides visible',
          tooManyBalesTooFarAway: 'Too many bales, too far away',
          unclearWhichIsMainBale: 'Unclear which is the main bale',
        },
        intro: 'Here are examples of good and bad photos:',
      },
    },
    aiBriquette: {
      partOne: {
        imageAlt: 'Stand 0.5 metre away max',
        instructions: '<bold>Stand 0.5 metres</bold> in front of the briquette.',
      },
      partTwo: {
        analysisInstruction: 'When analysing a pallet, <bold>take photos of min 6 briquettes.</bold>',
        captions: {
          goodDistance: 'Good distance',
          markingsVisible: 'Markings visible',
          noMarkingsVisible: 'No markings visible',
          okDistance: 'OK distance',
          tooDirty: 'Too dirty',
          tooShredded: 'Too shredded',
        },
        intro: 'Here are examples of good and bad photos:',
      },
    },
    aiLoose: {
      partTwo: {
        captions: {
          cannotSeeAllMaterial: 'Cannot see all the material',
          floorHasLargeMarkings: 'Floor has large markings',
          materialInsideBlackBox: 'Material is inside the black box',
          materialNotOnGroundOrTable: 'Material is not on ground/table',
          materialShouldNotTouchPurpleLines: 'The material should not touch the purple lines',
          materialSpreadVeryWell: 'Material is spread very well',
          materialSpreadWell: 'Material is spread well',
          materialTouchesEdge: 'Material touches the edge',
          shadow: 'Shadow',
          squareFullOfMaterial: 'The square is full of material',
          tooHeapedAndTooBig: 'Too heaped and too big',
        },
        intro: 'Here are examples of good and bad photos:',
      },
    },
    alert: {
      actions: {
        startGuide: 'Start guide - 1 min',
      },
      description: {
        obfuscatedAi: 'Read this short guide to take the right photos.',
        withAi: 'Read this short guide to take the right photos for accurate AI results. Bad photos = bad results.',
      },
      title: 'First time using {{modelTitle}}?',
    },
    autoCaptureTip: {
      message:
        'Pro tip! Go faster and keep your gloves on with <autoCapture>Auto capture</autoCapture> which automatically takes photos for you.',
    },
    common: {
      actions: {
        back: 'Back',
        finish: 'Finish',
        next: 'Next',
        skipGuide: 'Skip guide',
      },
      models: {
        bale: 'bale',
        briquette: 'briquette',
      },
    },
    complete: {
      message:
        "When you are finished, tap <complete>'Complete'</complete> in the camera. You will then see the <qualityReport>Quality report.</qualityReport>",
    },
    dialog: {
      stepLabel: 'Step {{currentStep}}/{{maxSteps}}',
      title: 'Welcome to {{modelTitle}}!',
    },
    guideTitle: {
      obfuscatedAi: 'Learn how to take photos correctly to get the best results.',
      withAi: 'Learn how to take photos correctly to get the best AI results.',
    },
    offlineWarning: {
      message:
        'Pro tip! Turn on <offlineMode>Offline mode</offlineMode> to avoid losing photos when your data connection is weak.',
    },
    reviewDeleteHelpText: {
      withAi:
        'You can see if a {{model}} has been <accepted>accepted</accepted> or <rejected>rejected</rejected> by the AI. <delete>Delete</delete> and <retake>retake</retake> incorrect photos.',
      withoutAi:
        'You can see if a {{model}} has been <accepted>accepted</accepted> or <rejected>rejected</rejected>. <delete>Delete</delete> and <retake>retake</retake> incorrect photos.',
    },
    reviewDeleteTip: {
      message:
        'Top tip! You can also <reviewDelete>review, delete</reviewDelete> and <addMorePhotos>add more photos</addMorePhotos> in the Quality Report.',
    },
  },
  instructions: {
    photoInstructionsDrawer: {
      actions: {
        doNotShowAgain: 'Do not show again',
        takePhoto: 'Take Photo',
      },
      description:
        'Our AI analyses uploaded images on multiple parameters. Your uploaded images should look like the below.',
      frontFaceDescription:
        'The most common cause of an invalid image is due to bale orientation. The objects in the bale should be flattened and face-on.',
      frontFaceTitle: 'What is front face?',
      imageAlt: {
        balePhotoExample: 'Bale photo example',
        frontFaceBalePhoto: 'Front face bale photo',
        treeRingBalePhoto: 'Tree ring bale photo',
      },
      labels: {
        objectsFlattenedFaceOn: 'Objects flattened & face-on',
        objectsSquashedSideOn: 'Objects squashed & side-on',
      },
      title: 'Taking images',
    },
  },
  materialComponents: {
    supportedComponent: {
      labels: {
        materialComponent: 'Material component',
      },
    },
    supportedComponentValue: {
      adornments: {
        max: 'Max: ',
        min: 'Min: ',
      },
      labels: {
        booleanValue: 'Boolean value',
        value: 'Value',
      },
    },
  },
  navigation: {
    sidebar: {
      closeAriaLabel: 'Close',
    },
    userMenu: {
      language: 'Language',
      logOut: 'Log out',
      manageCompany: 'Manage company',
      notifications: 'Notification settings',
      qualityDigest: 'Daily quality email',
    },
  },
  networkStatus: {
    alert: {
      offlineMessage: 'You are currently offline, evidence will be stored locally until you are back online.',
    },
    override: {
      label: 'Offline mode',
      notifications: {
        disabled: 'Offline mode disabled',
        enabled: 'Offline mode enabled',
      },
    },
  },
  omnisearch: {
    noOptions: {
      withValue: 'No results found',
      withoutValue: 'Type to search',
    },
    placeholder: {
      desktop: 'Ctrl/Cmd + K to search',
      mobile: 'Search',
    },
  },
  qualityReport: {
    footer: {
      backToSiteQualityPage: 'Back to site quality page',
    },
    link: {
      buttonLabel: 'Quality Report',
      tooltip: {
        noMaterialSelected: 'No material selected',
        notEnoughEvidence: 'Not enough evidence for selected material',
      },
    },
    page: {
      notAvailable: 'Quality Report not available',
    },
    sampleControls: {
      actions: {
        viewData: 'View Data',
      },
    },
    sampleSelect: {
      label: 'Inspection date',
    },
    share: {
      content: "Here is the link for {{brandName}}'s quality report {{url}}",
      labels: {
        copyLink: 'Copy link',
        copyNotification: 'Copied to clipboard',
        download: 'Download',
        email: 'Email',
        systemShare: 'System share',
        trigger: 'Share',
        triggerAriaLabel: 'Share',
        whatsapp: 'WhatsApp',
      },
      subject: '{{brandName}} Quality Report',
    },
  },
  siteMaterial: {
    tradeCompanySiteMaterialPicker: {
      actions: {
        addNewMaterial: 'Add new material',
        addNewMaterialAriaLabel: 'Add new material',
      },
      labels: {
        company: 'Company',
        siteMaterial: 'Site Material',
      },
    },
  },
} as const;
